import {type OpenCameraBtnProps} from './OpenCameraBtn.shared'

export function OpenCameraBtn(_props: OpenCameraBtnProps) {
  return null
}
